/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';
// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_CLAIM,
  screenData: data,
});

export const setPaginationIndex = (value) => ({
  type: actionTypes.SET_PAGINATION_INDEX_PROVIDER_CLAIM_LISTING,
  payload: value,
});
// dispatch Quarter From
export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_FROM_CLAIM,
  payload: data,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_CLAIM,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgClaim = (data) => ({
  type: actionTypes.GET_ERROR_MSG_CLAIM,
  payload: data,
});

// error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(dispatchErrorMsgClaim([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgClaim([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};
// refresh data
export const refreshDProviderClaim = () => ({
  type: actionTypes.SET_REFRESH_DATA_CLAIM,
  payload: {},
});
export const refreshDProviderClaimDisplay = () => ({
  type: actionTypes.SET_DISPLAY_DATA_CLAIM,
  payload: {},
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_CLAIM,
  payload: data,
});
// on toggle rebate program
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_CLAIM,
  payload: data,
});

//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};
// selected report
export const dispatchProviderSelection = (data) => ({
  type: actionTypes.SET_PROVIDER_SELECTION_CLAIM,
  payload: data,
});
// reference data
export const dispatchReferenceData = (data) => ({
  type: actionTypes.SET_PROVIDER_REFERENCE_CLAIM,
  payload: data,
});
export const getReferenceData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER_CLAIM_REFERENCE_DATA, value)
    .then((response) => {
      return dispatch(dispatchReferenceData(response.data));
    })
    .catch((response) => {
      dispatch(dispatchReferenceData([]));
    });
};
// provider list
export const dispatchProviderList = (data) => ({
  type: actionTypes.SET_PROVIDER_LIST_CLAIM,
  payload: data,
});
export const getProviderList = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER_CLAIM_PROVIDER_DATA, value)
    .then((response) => {
      return dispatch(dispatchProviderList(response.data));
    })
    .catch((response) => {
      dispatch(dispatchProviderList([]));
    });
};
// provider data
export const dispatchProviderData = (data) => ({
  type: actionTypes.SET_PROVIDER_DATA_CLAIM,
  payload: data,
});
export const getURAData = (value) => () => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER_CLAIM_DATA, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
export const getProviderData = (value) => async (dispatch) => {
  dispatch(dispatchProviderData([]));
  try {
    const response = await axios.post(serviceEndPoint.GET_PROVIDER_CLAIM_DATA, value);
    const data = response.data.providerclaimListingDetails?.detailPageGridList || [];

    if (data.length === 0) {
      dispatch(showNoDataMessage());
    } else {
      dispatch(dispatchProviderData(response.data));
    }
    return data; // <-- important
  } catch (error) {
    dispatch(dispatchProviderData([]));
    return []; // <-- return something so await works
  }
};
export const getProviderData1 = (value) => async (dispatch) => {
  try {
    const response = await axios.post(serviceEndPoint.GET_PROVIDER_CLAIM_DATA, value);
    const data = response.data.providerclaimListingDetails?.detailPageGridList || [];

    if (data.length === 0) {
    } else {
    }
    return data; 
  } catch (error) {
    return []; 
  }
};




export const dispatchProviderGridData = (data) => ({
  type: actionTypes.SET_PROVIDER_GRID_DATA_CLAIM,
  payload: data,
});
// dispatch Display screen Object
export const dispatchDisplayObjClaim = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_CLAIM,
  payload: data,
});

export const getProviderIdsList = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_PROVIDER_ID_LIST}`, values)
    .then((response) => {
      return response.data?.providerclaimListingDetails?.providerIds||[]
      }
    )
    .catch((response) => []);
};
